/*eslint-env browser*/
import download from "./download.js"

const {blobToBase64} = download


const conversions = {

    toImageData: canvas => {
        const ctx = canvas.getContext("2d")
        return ctx.getImageData(0, 0, canvas.width, canvas.height)
    },

    toDataURL:     canvas => canvas.toDataURL(),

    toImageBitmap: canvas => createImageBitmap(canvas), //this is a promise


    //FIXME read this : https://stackoverflow.com/questions/55074270/why-do-canvas-toblob-and-canvas-todataurl-have-different-return-types
    //async
    toBlob: (canvas, params = {}) => {
        const {type = "image/png", quality} = params
        return new Promise((resolve) => {
            canvas.toBlob(resolve, type, quality)
        })
    },


    toBase64: (canvas, params = {}) => {
        return conversions.toBlob(canvas, params)
            .then(blobToBase64)
    },


    toImageElement: (canvas) => {
        const dataURL = canvas.toDataURL()
        const img = document.createElement("img")
        img.src = dataURL
        return img
    },


    // returns a promise that waits until the image is loaded.
    // if the html element (not loaded yet) is what matters, use toImageElement
    toPNGImage: (canvas, params = {}) => {
        const mimeType = "image/png"
        const image = new Image()
        return new Promise(resolve => {
            image.addEventListener("load", () => {
                resolve(image)
                if (params.whenLoaded) {
                    params.whenLoaded(image)
                }
            })
            image.src = canvas.toDataURL(mimeType)
        })
    }


}


function tempCanvasFromImageOrCanvas (image, {cropSource, flip, widthInPixels, heightInPixels}, {useOpacity = true}) {
    const {width, height, topLeftX, topLeftY} = cropSource

    const canvas  = document.createElement("canvas")
    canvas.width  = widthInPixels
    canvas.height = heightInPixels
    const cx = canvas.getContext("2d")

    if (!useOpacity) {
        cx.fillStyle = "#ffffff"
        cx.fillRect(0, 0, widthInPixels, heightInPixels)
    }
        

    turnOffSmoothing(cx) //FIXME

    cx.save()

    if (flip === "horizontal") {
        cx.translate(widthInPixels, 0)
        cx.scale(-1, 1)
    } else if (flip === "vertical") {
        cx.translate(0, heightInPixels)
        cx.scale(1, -1)
    }

    cx.drawImage(
        image,
        topLeftX,      topLeftY,
        width, height,
        0,             0,
        widthInPixels, heightInPixels
    )

    cx.restore()

    return canvas
}



function turnOffSmoothing (cx) {
    cx.imageSmoothingEnabled    = false
    cx.mozImageSmoothingEnabled = false
    cx.msImageSmoothingEnabled  = false
}



// snapshot for log thumbnails (rich_value.js): always a NEW canvas, because
// sources may be live surfaces (a screen's canvas) or shared temp canvases.
// Never upscales - tiny pixel-art sources stay at native size and let the
// display layer do a pixelated CSS upscale instead of a resampled one.
const thumbnailMaxSize = 160

function toThumbnailCanvas (source, maxSize = thumbnailMaxSize) {
    const largestSide = Math.max(source.width, source.height, 1)
    const scale       = Math.min(1, maxSize / largestSide)

    const canvas  = document.createElement("canvas")
    canvas.width  = Math.max(1, Math.round(source.width * scale))
    canvas.height = Math.max(1, Math.round(source.height * scale))

    canvas.getContext("2d").drawImage(source, 0, 0, canvas.width, canvas.height)
    return canvas
}



export default {
    conversions,
    tempCanvasFromImageOrCanvas,
    toThumbnailCanvas
}

